import React, { forwardRef } from 'react';
import { Icons } from '../icons/icons';
import { ErrorMessage } from './error';

type Props = {
  name: string;
  value?: string;
  className?: string;
  label?: string;
  errors?: any;
};

export const FileInput = (className: string): any => forwardRef((props: Props, ref: any): JSX.Element => {
  const { errors, ...otherProps } = props;
  const errorClassName = errors?.[otherProps.name] ? 'invalid' : '';
  const mergedProps = { id: props.name, ...props, className: `form-control file-input ${className} ${props.className || ''} ${errorClassName}` };
  return <>
    <div className="position-relative">
      <input ref={ref} type="file" { ...mergedProps } />
      <Icons.ArrowDown className="select-arrow" width={className === 'select-sm' ? '18' : undefined} />
    </div>
    {errors?.[otherProps.name]?.message && <ErrorMessage>{errors[otherProps.name].message}</ErrorMessage>}
  </>;
});

export const FileInputLarge = FileInput('input-lg');
export const FileInputSmall = FileInput('');
